var styles = {"box":"Button_box_xi3nd_1","margin-forgot-password":"Button_margin-forgot-password_xi3nd_11","margin-top":"Button_margin-top_xi3nd_14"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
